import { Pipe, PipeTransform } from '@angular/core';
import { InstallerTeamMember, isInstallerMember, User } from '~gc/domains/users/user/user.model';

@Pipe({ name: 'isInstallerTeamMember' })
export class IsInstallerTeamMemberPipe implements PipeTransform {
  transform(user: User | InstallerTeamMember): boolean {
    return isInstallerMember(user);
  }
}
